//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Fields.js";
import "../no/ScCollector.js";
let d=[[[1,"BallDiameter",0,"Expression",1],[0,"BallDiameterField",0,"Fields.ScalarFieldWrapper",0],[0,"BallsOption",1,0],[1,"BlendFactor",0,"Expression",0],[1,"BulkFaces",0,"ScCollector",0],[1,"FactorToRodDiameter",0,"Expression",0],[0,"IncreaseBallThickness",1,0],[0,"IncreaseRodThickness",1,0],[1,"LatticeBodies",0,"ScCollector",0],[1,"MaxDistanceFromBulk",0,"Expression",0],[1,"MaxFactorForBallThickness",0,"Expression",0],[1,"MaxFactorForRodThickness",0,"Expression",0],[0,"ModifyBalls",1,1],[0,"ModifyOption",1,1],[0,"ModifyRods",1,0],[0,"RodDiameter",0,"Fields.ScalarFieldWrapper",0],[0,"TessellationFactor",1,0]],[],[]];
SPLM.Features.RodThicknessBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.RodThicknessBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.RodThicknessBuilder.ModifyOptions = Object.freeze({
    "Rods" : "Rods", "Balls" : "Balls", "Both" : "Both"});

SPLM.Features.RodThicknessBuilder.BallsOptions = Object.freeze({
    "None" : "None", "AbsoluteSize" : "AbsoluteSize", "RelativeSize" : "RelativeSize", "OnlyOrganicBlends" : "OnlyOrganicBlends", "KeepExisting" : "KeepExisting"});

SPLM.Features.RodThicknessBuilder.OriginalBodyOptions = Object.freeze({
    "Delete" : "Delete"});

export default SPLM;